/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useLazyQuery } from '@apollo/client';
import { SEND_CUSTOM_NOTIFICATION } from 'pages/Notifications/NotificationGraphQL';
import {
  customNotificationValidationSchema,
  PlATFORM_TYPE,
} from 'pages/Notifications/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import CustomNotificationForm from './components/CustomNotificationForm';

const CustomNotification = ({ toggleCustomNotification }) => {
  const [sendCustomNotificationToTrader] = useLazyQuery(
    SEND_CUSTOM_NOTIFICATION,
    {
      onCompleted: ({ sendCustomNotificationToTrader }) => {
        toast.success(sendCustomNotificationToTrader);
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.forEach(({ message }) => {
          toast.error(message);
        });
      },
      fetchPolicy: 'network-only',
    },
  );

  const getMappedOsType = (platformId) => {
    const normalizedPlatform = String(platformId || '').toLowerCase();
    const platformMap = {
      all: 'ALL',
      web: 'WEB',
      android: 'ANDROID',
      ios: 'IOS',
    };

    return platformMap[normalizedPlatform] || platformId;
  };

  const handleSubmit = async (values) => {
    const selectedNotificationType = values?.notificationType?.id;
    const shouldSendImage = selectedNotificationType === 'GIF';

    const payload = {
      description: values?.message,
      subject: values?.title,
      osType: getMappedOsType(values?.platform_type?.id),
      imageUrl: shouldSendImage ? values?.imageUrl : null,
      videoUrl: null,
      notificationType: selectedNotificationType,
    };

    if (values?.schedulerEnabled && values?.scheduledAt) {
      payload.scheduledAt = moment(values.scheduledAt).format(
        'YYYY-MM-DDTHH:mm:ssZ',
      );
    }

    await sendCustomNotificationToTrader({
      variables: payload,
    });
    toggleCustomNotification();
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={{
            title: '',
            message: '',
            platform_type: PlATFORM_TYPE[0],
            imageUrl: '',
            notificationType: { id: 'TEXT', label: 'TEXT' },
            videoUrl: '',
            schedulerEnabled: false,
            scheduledAt: '',
          }}
          enableReinitialize
          validationSchema={customNotificationValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <CustomNotificationForm
                {...props}
                toggleCustomNotification={toggleCustomNotification}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default CustomNotification;
